<template>
  <div class="container-fluid min-vh-100">
    <div class="row d-flex justify-content-center align-items-center min-vh-100">
      <div class="col-12 col-sm-6 col-lg-5 col-xl-3 bg-white">
        <div class="text-center mb-4">
          <img class="w-50" src="../../assets/img/rm-logo.svg" alt="RestMonster logotype">
          <h4 class="text-center mt-2 mb-0">{{ $t('auth.signInTitle') }}</h4>
        </div>
        <div class="mb-3 d-block">
          <label for="userEmail" class="form-label small text-muted">{{ $t('auth.email') }}</label>
          <input v-model.trim="this.email" type="email" class="form-control" id="userEmail"
                 :class="v$.email.$error ? 'border-danger' : ''">
        </div>
        <div class="mb-3 d-block">
          <label for="userPassword" class="form-label small text-muted">{{ $t('auth.password') }}</label>
          <input v-model.trim="this.password" type="password" class="form-control" id="userPassword"
                 :class="v$.password.$error ? 'border-danger' : ''"
                 v-on:keyup.enter="enterSignIn">
        </div>
        <div class="mb-3 pt-2 d-block text-center">
          <button v-if="this.loader" type="button" class="btn btn-outline-dark" disabled>
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            <span> {{ $t('auth.btn.loading') }}</span>
          </button>
          <button v-else @click="signIn" type="button" class="btn btn-outline-dark"
                  :class="v$.$invalid ? 'disabled': ''">
             {{ $t('auth.btn.login') }}
          </button>
        </div>
        <div class="mb-3 d-block d-flex justify-content-between">
          <router-link tag="button" to="/forgotpassword" class="link-dark">{{ $t('auth.btn.forgotPassword') }}</router-link>
          <router-link tag="button" to="/checkin" class="link-dark">{{ $t('auth.btn.createAccount') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import {mapGetters} from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import i18n from "@/i18n";
import {required, email, minLength} from '@vuelidate/validators'
export default {
  name: "SignIn",
  setup () {
    return { v$: useVuelidate({ $autoDirty: true})}
  },
  data() {
    return {
      email: '',
      password: '',
      loader: false,
    }
  },
  computed: {
    errCode() {
      return this.$store.state.errCode
    },
    ...mapGetters([
      'AUTHENTICATED'
    ]),
  },
  created() {
    if (this.AUTHENTICATED) {
      router.push('/')
    }
  },
  methods: {
    signIn() {
      this.loader = true
      var authData = {
        Username: this.email,
        Password: this.password
      }
      this.$store.dispatch('signIn', authData);
    },
    enterSignIn() {
      !this.v$.$invalid ? this.signIn() : false
    }
  },
  validations() {
    return {
      email: { required, email },
      password: { required, minLengthValue: minLength(6) }
    }
  },
  watch: {
    errCode () {
      if (this.errCode !== '') {
        if (this.errCode === '"NotAuthorizedException"') {
          this.$store.dispatch('addNewNotice', {text: i18n.global.t('auth.err.NotAuthorizedException'), error: true})
        } else if (this.errCode === '"UserNotConfirmedException"') {
          this.$store.dispatch('addNewNotice', {text: i18n.global.t('auth.err.UserNotConfirmedException'), error: true})
        } else if (this.errCode === '"UserNotFoundException"') {
          this.$store.dispatch('addNewNotice', {text: i18n.global.t('auth.err.UserNotFoundException'), error: true})
        } else if (this.errCode === '"InvalidParameterException"') {
          this.$store.dispatch('addNewNotice', {text: i18n.global.t('auth.err.InvalidParameterException'), error: true})
        } else {
          this.$store.dispatch('addNewNotice', {text: this.errCode, error: true})
        }
      }
      this.loader = false
    }
  }

}
</script>

<style scoped>

</style>
